export default "__VITE_ASSET__CuO_$j_d__"